const vernacular = {  
    "variantNew_h2_frequently_compare":{  
       "en":"Frequently </br> Compared Together",
       "hin":"\u0905\u0915\u094D\u0938\u0930 </br> \u090F\u0915 \u0938\u093E\u0925 \u0924\u0941\u0932\u0928\u093E \u092E\u0947\u0902"
    },
    "variantNew_a_compare_link":{  
       "en":"Compare",
       "hin":"\u0924\u0941\u0932\u0928\u093E"
    },
    "variantNew_span_offers_cont_label":{  
       "en":"Offers",
       "hin":"\u092A\u094D\u0930\u0938\u094D\u0924\u093E\u0935"
    },
    "variantNew_div_offer_name":{  
       "en":"This product is already at its Best Price-\nNo other offer/coupon is valid on this product",
       "hin":"\u092F\u0939 \u0909\u0924\u094D\u092A\u093E\u0926 \u092A\u0939\u0932\u0947 \u0938\u0947 \u0939\u0940 \u0905\u092A\u0928\u0947 \u0938\u0930\u094D\u0935\u0936\u094D\u0930\u0947\u0937\u094D\u0920 \u092E\u0942\u0932\u094D\u092F \u092A\u0930 \u0939\u0948\u0964 \u0907\u0938 \u0909\u0924\u094D\u092A\u093E\u0926 \u092A\u0930 \u0915\u094B\u0908 \u0905\u0928\u094D\u092F \u0911\u092B\u093C\u0930 / \u0915\u0942\u092A\u0928 \u092E\u093E\u0928\u094D\u092F \u0928\u0939\u0940\u0902 \u0939\u0948"
    },
    "variantNew_product_rank_new_ranked":{  
       "en":"Ranked No.",
       "hin":"\u0930\u0948\u0902\u0915 \u0928\u0902\u092C\u0930_"
    },
    "variantNew_product_rank_new_in":{  
       "en":"in",
       "hin":""
    },
    "variantNew_span_price_txt_MRP":{  
       "en":"MRP:",
       "hin":"\u090F\u092E\u0906\u0930\u092A\u0940:"
    },
    "variantNew_span_price_txt_Price":{  
       "en":"Price:",
       "hin":"\u092E\u0942\u0932\u094D\u092F:"
    },
    "variantNew_span_price_txt_Offer_price":{  
       "en":"Offer Price:",
       "hin":"\u0911\u092B\u0930 \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u092E\u0942\u0932\u094D\u092F:"
    },
    "variantNew_span_variant_discount_small_off":{  
       "en":"off",
       "hin":"\u092E\u093E\u092B"
    },
    "variantNew_span_variant_discount_off":{  
       "en":"Off",
       "hin":"\u092E\u093E\u092B"
    },
    "variantNew_a_view_more":{  
       "en":"View More",
       "hin":"\u0914\u0930 \u0926\u0947\u0916\u094B"
    },
    "variantNew_a_view_less":{
        "en":"View Less",
        "hin":"\u0915\u092E \u0926\u0947\u0916\u0947\u0902"
    },
    "variantNew_a_s_emi_link_tr_emi":{  
       "en":"(EMI starts from \u20B9",
       "hin":"(EMI \u0936\u0941\u0930\u0942 \u0939\u094B\u0924\u093E \u0939\u0948 \u20B9"
    },
    "variantNew_label_check_delivery":{  
       "en":"Check Delivery:",
       "hin":"\u0921\u093F\u0932\u0940\u0935\u0930\u0940 \u0915\u0940 \u091C\u093E\u0902\u091A \u0915\u0930\u0947\u0902:"
    },
    "variantNew_input_enter_pincode":{  
       "en":"Enter pin code",
       "hin":"\u092A\u093F\u0928\u0915\u094B\u0921 \u0926\u0930\u094D\u091C"
    },
    "variantNew_rtng_star_reviews":{  
       "en":"Reviews",
       "hin":"\u0938\u092E\u0940\u0915\u094D\u0937\u093E"
    },
    "variantNew_input_Check":{  
       "en":"Check",
       "hin":"\u091A\u0947\u0915"
    },
    "variantNew_div_normally_delivered_in":{  
       "en":"Generally delivered in",
       "hin":"(\u0906\u092E \u0924\u094C\u0930 \u092A\u0930"
    },
    "variantNew_div_days":{  
       "en":"business days",
       "hin":"\u0935\u094D\u092F\u093E\u0935\u0938\u093E\u092F\u093F\u0915 \u0926\u093F\u0928\u094B\u0902 \u092E\u0947\u0902 \u0926\u093F\u092F\u093E)"
    },
    "variantNew_pin_data_your_pin":{  
       "en":"Your PIN:",
       "hin":"\u0906\u092A\u0915\u093E \u092A\u093F\u0928:"
    },
    "variantNew_pin_data_change":{  
       "en":"Change",
       "hin":"\u092F\u0939\u093E\u0902 \u092C\u0926\u0932\u0947\u0902"
    },
    "variantNew_pin_data_shipped_by":{  
       "en":"Shipped by :",
       "hin":"\u092D\u0947\u091C\u0928\u0947 \u0915\u0940 \u0924\u093F\u0925\u093F :"
    },
    "variantNew_pin_data_delivered_by":{  
       "en":"Delivered by :",
       "hin":"\u0935\u093F\u0924\u0930\u093F\u0924 \u0924\u093F\u0925\u093F :"
    },
    "variantNew_pin_data_cod_msg":{  
       "en":"Cash on delivery available",
       "hin":"\u0921\u093F\u0932\u0940\u0935\u0930\u0940 \u092A\u0930 \u0915\u0948\u0936 \u0909\u092A\u0932\u092C\u094D\u0927"
    },
    "variantNew_input_buynow":{  
       "en":" Buy Now",
       "hin":"\u0916\u0930\u0940\u0926\u0947\u0902"
    },
    "variantNew_input_addtocart":{  
       "en":" Add To Cart",
       "hin":"\u0915\u093E\u0930\u094D\u091F \u092E\u0947\u0902 \u0921\u093E\u0932\u0947\u0902"
    },
    "variantNew_notifyme_msg_unavailable_msg":{  
       "en":"This variant is currently unavailable, we will contact you when it is available_",
       "hin":"\u092F\u0939 \u0938\u0902\u0938\u094D\u0915\u0930\u0923 \u0935\u0930\u094D\u0924\u092E\u093E\u0928 \u092E\u0947\u0902 \u0905\u0928\u0941\u092A\u0932\u092C\u094D\u0927 \u0939\u0948, \u091C\u092C \u0939\u092E \u0909\u092A\u0932\u092C\u094D\u0927 \u0939\u094B\u0902\u0917\u0947, \u0924\u094B \u0939\u092E \u0906\u092A\u0938\u0947 \u0938\u0902\u092A\u0930\u094D\u0915 \u0915\u0930\u0947\u0902\u0917\u0947_"
    },
    "variantNew_preOrder_msg_enter_details_msg":{  
       "en":"Enter your details and we will contact you when the product is launched_",
       "hin":"\u0905\u092A\u0928\u093E \u0935\u093F\u0935\u0930\u0923 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902 \u0914\u0930 \u0909\u0924\u094D\u092A\u093E\u0926 \u0936\u0941\u0930\u0942 \u0939\u094B\u0928\u0947 \u092A\u0930 \u0939\u092E \u0906\u092A\u0938\u0947 \u0938\u0902\u092A\u0930\u094D\u0915 \u0915\u0930\u0947\u0902\u0917\u0947_"
    },
    "variantNew_packs_links_save_more":{  
       "en":"Save More:",
       "hin":"\u0905\u0927\u093F\u0915 \u092C\u091A\u093E\u0913:"
    },
    "variantNew_link_write_a_review":{  
       "en":"Write a review",
       "hin":"\u0938\u092E\u0940\u0915\u094D\u0937\u093E \u0932\u093F\u0916\u0947"
    },
    "variantNew_span_add_to_compare":{  
       "en":"Add to Compare",
       "hin":"\u0924\u0941\u0932\u0928\u093E \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u091C\u094B\u0921\u093C\u0947\u0902"
    },
    "variantNew_div_expert_title":{  
       "en":"Ask an Expert",
       "hin":"\u0935\u093F\u0936\u0947\u0937\u091C\u094D\u091E \u0938\u0947 \u092A\u0942\u091B\u0947\u0902"
    },
    "variantNew_span_expert_phone":{  
       "en":"Call",
       "hin":"\u0915\u0949\u0932"
    },
    "variantNew_span_expert_timetable":{  
       "en":"Mon - Sat (10AM - 7PM)",
       "hin":"\u0938\u094B\u092E - \u0936\u0928\u093F (10AM - 7 PM)"
    },
    "variantNew_section_header_product_details":{  
       "en":"Product Details",
       "hin":"\u092A\u094D\u0930\u094B\u0926\u0941\u0915\u094D\u0924 \u0935\u093F\u0935\u0930\u0923"
    },
    "variantNew_span_sold_by":{  
       "en":"Sold by:",
       "hin":"\u0935\u093F\u0915\u094D\u0930\u0947\u0924\u093E:"
    },
    "variantNew_span_manufacturer":{  
       "en":"Manufacturer:",
       "hin":"\u0909\u0924\u094D\u092A\u093E\u0926\u0915:"
    },
    "variantNew_span_manufactured":{  
      "en":"Manufactured By : ",
      "hin":"\u0909\u0924\u094D\u092A\u093E\u0926\u0915:"
    },
    "variantNew_span_importer":{  
       "en":"Importer:",
       "hin":"\u0906\u092F\u093E\u0924\u0915:"
    },
    "variantNew_span_packer":{  
       "en":"Packer:",
       "hin":"\u0932\u092A\u0947\u091F\u0928\u0947\u0935\u093E\u0932\u093E:"
    },
    "variantNew_span_customer_care":{  
       "en":"Customer Care:",
       "hin":"\u0917\u094D\u0930\u093E\u0939\u0915 \u0938\u0947\u0935\u093E:"
    },
    "variantNew_span_emi_name":{  
       "en":"EMI Details",
       "hin":"EMI \u0935\u093F\u0935\u0930\u0923"
    },
    "variantNew_th_emi_tenure":{  
       "en":"EMI Tenure (months)",
       "hin":"EMI \u0915\u093E\u0930\u094D\u092F\u0915\u093E\u0932 (\u092E\u0939\u0940\u0928\u094B\u0902)"
    },
    "variantNew_th_bank_interest":{  
       "en":"Bank Interest Rate (%)",
       "hin":"\u092C\u0948\u0902\u0915 \u0915\u0940 \u092C\u094D\u092F\u093E\u091C \u0926\u0930 (%)"
    },
    "variantNew_th_monthly_installment":{  
       "en":"Monthly Installments",
       "hin":"\u092E\u093E\u0938\u093F\u0915 \u0915\u093F\u0936\u094D\u0924"
    },
    "variantNew_th_total_amt":{  
       "en":"Total Amount",
       "hin":"\u0915\u0941\u0932 \u0930\u0915\u092E"
    },
    "variantNew_a_info":{  
       "en":"Info",
       "hin":"\u091C\u093E\u0928\u0915\u093E\u0930\u0940"
    },
    "variantNew_a_details":{  
       "en":"Details",
       "hin":"\u0935\u093F\u0935\u0930\u0923"
    },
    "variantNew_a_supplement_info":{  
       "en":"Supplement Info",
       "hin":"\u0938\u092A\u094D\u0932\u0940\u092E\u0947\u0902\u091F \u0915\u0940 \u091C\u093E\u0928\u0915\u093E\u0930\u0940"
    },
    "variantNew_div_was_this_product_description_useful":{  
       "en":"Was this product description useful?",
       "hin":"\u0907\u0938 \u0909\u0924\u094D\u092A\u093E\u0926 \u0915\u093E \u0935\u093F\u0935\u0930\u0923 \u0909\u092A\u092F\u094B\u0917\u0940 \u0925\u093E?"
    },
    "variantNew_a_fnt_bold_txt_blue_js_prdct_desc_tr_descFeedbackYes":{  
       "en":"Yes",
       "hin":"\u0939\u093E\u0901"
    },
    "variantNew_a_fnt_bold_txt_blue_js_prdct_desc_tr_descFeedbackNo":{  
       "en":"No",
       "hin":"\u0928\u0939\u0940\u0902"
    },
    "variantNew_div_disclaimer_pdp":{  
       "en":"Disclaimer:",
       "hin":"\u0905\u0938\u094D\u0935\u0940\u0915\u0930\u0923:"
    },
    "variantNew_div_disclaimer_pdp_info":{  
       "en":" Information and statements regarding the product/services have not been evaluated by the Food and Drug Administration or any government authority and not intended to diagnose, treat, cure, or prevent any disease_ Product/Services reviews are provided by users based on their persona, experiences & opinions, and do not reflect the opinion of HealthKart_ Product/Services information provided by the seller on HealthKart is not exhaustive, please read the label on the product carefully for complete information provided by the manufacturer_ The results from the products will vary from person to person_ No individual result should be seen as typical_",
       "hin":"\u0938\u0942\u091A\u0928\u093E \u0914\u0930 \u0909\u0924\u094D\u092A\u093E\u0926 \u0915\u0947 \u092C\u093E\u0930\u0947 \u092E\u0947\u0902 \u092C\u092F\u093E\u0928 / \u0938\u0947\u0935\u093E\u0913\u0902 \u0916\u093E\u0926\u094D\u092F \u090F\u0935\u0902 \u0914\u0937\u0927\u093F \u092A\u094D\u0930\u0936\u093E\u0938\u0928 \u092F\u093E \u0915\u093F\u0938\u0940 \u0938\u0930\u0915\u093E\u0930\u0940 \u092A\u094D\u0930\u093E\u0927\u093F\u0915\u0930\u0923 \u0926\u094D\u0935\u093E\u0930\u093E \u092E\u0942\u0932\u094D\u092F\u093E\u0902\u0915\u0928 \u0928\u0939\u0940\u0902 \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u0939\u0948 \u0914\u0930, \u0928\u093F\u0926\u093E\u0928 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0907\u0932\u093E\u091C, \u0907\u0932\u093E\u091C, \u092F\u093E \u0915\u093F\u0938\u0940 \u092D\u0940 \u092C\u0940\u092E\u093E\u0930\u0940 \u0915\u094B \u0930\u094B\u0915\u0928\u0947 \u0915\u093E \u0907\u0930\u093E\u0926\u093E \u0928\u0939\u0940\u0902\u0964 \u0909\u0924\u094D\u092A\u093E\u0926 / \u0938\u0947\u0935\u093E \u0938\u092E\u0940\u0915\u094D\u0937\u093E \u0909\u0928\u0915\u0947 \u0935\u094D\u092F\u0915\u094D\u0924\u093F\u0924\u094D\u0935, \u0905\u0928\u0941\u092D\u0935\u094B\u0902 \u0914\u0930 \u0935\u093F\u091A\u093E\u0930\u094B\u0902 \u0915\u0947 \u0906\u0927\u093E\u0930 \u092A\u0930 \u0909\u092A\u092F\u094B\u0917\u0915\u0930\u094D\u0924\u093E\u0913\u0902 \u0926\u094D\u0935\u093E\u0930\u093E \u092A\u094D\u0930\u0926\u093E\u0928 \u0915\u0940 \u091C\u093E\u0924\u0940 \u0939\u0948\u0902, \u0914\u0930 HealthKart \u0915\u0940 \u0930\u093E\u092F \u0915\u094B \u092A\u094D\u0930\u0924\u093F\u092C\u093F\u0902\u092C\u093F\u0924 \u0928\u0939\u0940\u0902 \u0915\u0930\u0924\u0947\u0964 \u0909\u0924\u094D\u092A\u093E\u0926 / \u0938\u0947\u0935\u093E HealthKart \u092A\u0930 \u0935\u093F\u0915\u094D\u0930\u0947\u0924\u093E \u0926\u094D\u0935\u093E\u0930\u093E \u0909\u092A\u0932\u092C\u094D\u0927 \u0915\u0930\u093E\u0908 \u0917\u0908 \u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u0938\u0902\u092A\u0942\u0930\u094D\u0923 \u0928\u0939\u0940\u0902 \u0939\u0948, \u0915\u0943\u092A\u092F\u093E \u0932\u0947\u092C\u0932 \u0909\u0924\u094D\u092A\u093E\u0926 \u092A\u0930 \u0927\u094D\u092F\u093E\u0928 \u0938\u0947 \u0928\u093F\u0930\u094D\u092E\u093E\u0924\u093E \u0926\u094D\u0935\u093E\u0930\u093E \u092A\u094D\u0930\u0926\u093E\u0928 \u0915\u0940 \u092A\u0942\u0930\u0940 \u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u0915\u0947 \u0932\u093F\u090F \u092A\u0922\u093C\u0947\u0902\u0964 \u0909\u0924\u094D\u092A\u093E\u0926\u094B\u0902 \u0915\u0947 \u092A\u0930\u093F\u0923\u093E\u092E\u094B\u0902 \u0915\u094B \u0939\u0930 \u0935\u094D\u092F\u0915\u094D\u0924\u093F \u0915\u0947 \u0932\u093F\u090F \u0905\u0932\u0917 \u0905\u0932\u0917 \u0939\u094B\u0902\u0917\u0947\u0964 \u0915\u094B\u0908 \u0935\u094D\u092F\u0915\u094D\u0924\u093F\u0917\u0924 \u092A\u0930\u093F\u0923\u093E\u092E \u0920\u0947\u0920 \u0915\u0947 \u0930\u0942\u092A \u092E\u0947\u0902 \u0926\u0947\u0916\u093E \u091C\u093E\u0928\u093E \u091A\u093E\u0939\u093F\u090F"
    },
    "variantNew_h3_product_reviews":{  
       "en":"Customer Reviews",
       "hin":"\u0930\u0947\u091F\u093F\u0902\u0917 \u0914\u0930 \u0938\u092E\u0940\u0915\u094D\u0937\u093E"
    },
    "variantNew_fnt_bold_mrgn_b_10_m_head_rat_overall_rating":{  
       "en":"Overall rating",
       "hin":"\u0938\u092E\u0917\u094D\u0930 \u0930\u0947\u091F\u093F\u0902\u0917"
    },
    "variantNew_h3_pro_summary":{  
       "en":"Pro Summary",
       "hin":"\u092A\u094D\u0930\u094B \u0938\u093E\u0930\u093E\u0902\u0936"
    },
    "variantNew_span_based_on":{  
       "en":"Based on",
       "hin":"(\u092E\u0942\u0932\u094D\u092F\u093E\u0902\u0915\u0928"
    },
    "variantNew_span_rating":{  
       "en":"ratings",
       "hin":"\u0906\u0927\u093E\u0930 \u092A\u0930)"
    },
    "variantNew_h3_have_you_used_this_product":{  
       "en":"We would love to know what you feel about the product",
       "hin":"\u0915\u094D\u092F\u093E \u0906\u092A\u0928\u0947 \u092F\u0939 \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F \u0907\u0938\u094D\u0924\u0947\u092E\u093E\u0932 \u0915\u093F\u092F\u093E \u0939\u0948?"
    },
    "variantNew_p_rate_it_on_scale_of_5":{  
       "en":"Rate it on scale of 5",
       "hin":"5 \u0915\u0947 \u092A\u0948\u092E\u093E\u0928\u0947 \u092A\u0930 \u0907\u0938\u0915\u093E \u092E\u0942\u0932\u094D\u092F\u093E\u0902\u0915\u0928 \u0915\u0930\u0947\u0902"
    },
    "variantNew_s_param_based_on":{  
       "en":"Based on",
       "hin":"\u092E\u0942\u0932\u094D\u092F\u093E\u0902\u0915\u0928"
    },
    "variantNew_s_param_of":{  
       "en":"of",
       "hin":"\u0915\u0947"
    },
    "variantNew_s_param_ratings":{  
       "en":"ratings",
       "hin":" \u0906\u0927\u093E\u0930 \u092A\u0930"
    },
    "variant_rev_counts_showing":{  
       "en":"Showing",
       "hin":"\u0926\u093F\u0916\u093E \u0930\u0939\u093E \u0939\u0948&nbsp"
    },
    "variant_rev_counts_reviews":{  
       "en":"review(s)",
       "hin":"\u0938\u092E\u0940\u0915\u094D\u0937\u093E(\u0930\u094B\u0902)"
    },
    "variantNew_span_strikethrough_rs":{  
       "en":" ?",
       "hin":"\u20B9"
    },
    "variantNew_span_variant_loyalty_cash_text":{  
       "en":" Earn Gritzo Cash Upto",
       "hin":"Gritzo Cash \u0915\u092E\u093E\u090F\u0901"
    },
    "variantNew_span_variant_loyalty_cash":{  
       "en":" ?",
       "hin":"\u20B9"
    },
    "variantNew_img_auth_reseller_lazy":{  
       "en":"100% Authenticity Guaranteed",
       "hin":"100% \u092A\u094D\u0930\u093E\u092E\u093E\u0923\u093F\u0915\u0924\u093E \u0915\u0940 \u0917\u093E\u0930\u0902\u091F\u0940"
    },
    "variantNew_link_tr_writeReview":{  
       "en":"Write a Review",
       "hin":"\u0938\u092E\u0940\u0915\u094D\u0937\u093E \u0932\u093F\u0916\u0947"
    },
    "variantNew_feature_name_taste":{  
       "en":"Taste",
       "hin":"\u0938\u094D\u0935\u093E\u0926"
    },
    "variantNew_feature_name_mixability":{  
       "en":"Mixability",
       "hin":"\u092E\u093F\u0936\u094D\u0930\u0923"
    },
    "variantNew_feature_name_efficacy":{  
       "en":"Efficacy",
       "hin":"\u092A\u094D\u0930\u092D\u093E\u0935\u094B\u0924\u094D\u092A\u093E\u0926\u0915\u0924\u093E"
    },
    "variantNew_feature_name_value_for_money":{  
       "en":"Value for money",
       "hin":"\u092A\u0948\u0938\u0947 \u0915\u0940 \u0915\u0940\u092E\u0924"
    },
    "variantNew_p_emi_info":{  
       "en":"This table shows different banks and the respective EMI options based on the product price_ This is for indicative purposes only, your EMI payments may differ with total order amount and additional bank charges, if any_",
       "hin":"\u092F\u0939 \u0924\u093E\u0932\u093F\u0915\u093E \u0909\u0924\u094D\u092A\u093E\u0926 \u0915\u0940 \u0915\u0940\u092E\u0924 \u0915\u0947 \u0906\u0927\u093E\u0930 \u092A\u0930 \u0905\u0932\u0917_\u0905\u0932\u0917 \u092C\u0948\u0902\u0915\u094B\u0902 \u0914\u0930 \u0938\u0902\u092C\u0902\u0927\u093F\u0924 EMI \u0935\u093F\u0915\u0932\u094D\u092A \u0926\u093F\u0916\u093E\u0924\u0940 \u0939\u0948\u0964 \u092F\u0939 \u0915\u0947\u0935\u0932 \u0938\u0902\u0915\u0947\u0924\u0915 \u0909\u0926\u094D\u0926\u0947\u0936\u094D\u092F\u094B\u0902 \u0915\u0947 \u0932\u093F\u090F \u0939\u0948, \u0906\u092A\u0915\u0947 EMI \u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u0941\u0932 \u0906\u0926\u0947\u0936 \u0930\u093E\u0936\u093F \u0914\u0930 \u0905\u0924\u093F\u0930\u093F\u0915\u094D\u0924 \u092C\u0948\u0902\u0915 \u0936\u0941\u0932\u094D\u0915, \u092F\u0926\u093F \u0915\u094B\u0908 \u0939\u094B, \u0915\u0947 \u0938\u093E\u0925 \u0905\u0932\u0917 \u0939\u094B \u0938\u0915\u0924\u093E \u0939\u0948\u0964"
    },
    "variantNew_li_1_emi_info":{  
       "en":"Select your preferred EMI option at the time of payment_",
       "hin":"\u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u0947 \u0938\u092E\u092F \u0905\u092A\u0928\u093E \u092A\u0938\u0902\u0926\u0940\u0926\u093E EMI \u0935\u093F\u0915\u0932\u094D\u092A \u091A\u0941\u0928\u0947\u0902\u0964"
    },
    "variantNew_li_2_emi_info":{  
       "en":"Final EMI is calculated on the total value of your order at the time of payment_",
       "hin":"\u0905\u0902\u0924\u093F\u092E EMI \u0915\u093E \u092D\u0941\u0917\u0924\u093E\u0928 \u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u0947 \u0938\u092E\u092F \u0906\u092A\u0915\u0947 \u0911\u0930\u094D\u0921\u0930 \u0915\u0947 \u0915\u0941\u0932 \u092E\u0942\u0932\u094D\u092F \u092A\u0930 \u0915\u0940 \u091C\u093E\u0924\u0940 \u0939\u0948\u0964"
    },
    "variantNew_li_3_emi_info":{  
       "en":"The Bank charges annual interest rates according to the reducing monthly balance_ In the monthly reducing cycle, the principal is reduced with every EMI and the interest is calculated on the outstanding balance_",
       "hin":"\u092E\u093E\u0938\u093F\u0915 \u092E\u093E\u0938\u093F\u0915 \u0936\u0947\u0937 \u0930\u093E\u0936\u093F \u0915\u0947 \u0905\u0928\u0941\u0938\u093E\u0930 \u092C\u0948\u0902\u0915 \u0935\u093E\u0930\u094D\u0937\u093F\u0915 \u092C\u094D\u092F\u093E\u091C \u0926\u0930 \u0915\u093E \u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u0930\u0924\u093E \u0939\u0948\u0964 \u092E\u093E\u0938\u093F\u0915 \u0915\u091F\u094C\u0924\u0940 \u091A\u0915\u094D\u0930 \u092E\u0947\u0902, \u092A\u094D\u0930\u093F\u0902\u0938\u093F\u092A\u0932 \u092A\u094D\u0930\u0924\u094D\u092F\u0947\u0915 EMI \u0915\u0947 \u0938\u093E\u0925 \u0915\u092E \u0939\u094B \u091C\u093E\u0924\u093E \u0939\u0948 \u0914\u0930 \u092C\u0915\u093E\u092F\u093E \u0930\u093E\u0936\u093F \u0915\u094B \u092C\u0915\u093E\u092F\u093E \u0930\u093E\u0936\u093F \u092A\u0930 \u0917\u0923\u0928\u093E \u0915\u0940 \u091C\u093E\u0924\u0940 \u0939\u0948\u0964"
    },
    "variantNew_li_4_emi_info":{  
       "en":"NO processing fee is charged for availing HeathKart's EMI payment option_",
       "hin":"HealthKart \u0915\u0947 EMI \u092D\u0941\u0917\u0924\u093E\u0928 \u0935\u093F\u0915\u0932\u094D\u092A \u0915\u093E \u0932\u093E\u092D \u0932\u0947\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0915\u094B\u0908 \u092A\u094D\u0930\u094B\u0938\u0947\u0938\u093F\u0902\u0917 \u0936\u0941\u0932\u094D\u0915 \u0928\u0939\u0940\u0902 \u0932\u093F\u092F\u093E \u091C\u093E\u0924\u093E \u0939\u0948\u0964"
    },
    "variantNew_li_5_emi_info":{  
       "en":"In case of cancellation or return, interest charged by the bank till that time will not be refundable under any circumstances_ Partial cancellation is allowed_",
       "hin":"\u0930\u0926\u094D\u0926\u0940\u0915\u0930\u0923 \u092F\u093E \u0935\u093E\u092A\u0938\u0940 \u0915\u0947 \u092E\u093E\u092E\u0932\u0947 \u092E\u0947\u0902, \u0909\u0938 \u0938\u092E\u092F \u0924\u0915 \u092C\u0948\u0902\u0915 \u0926\u094D\u0935\u093E\u0930\u093E \u0932\u0917\u093E\u092F\u093E \u0917\u092F\u093E \u092C\u094D\u092F\u093E\u091C \u0915\u093F\u0938\u0940 \u092D\u0940 \u092A\u0930\u093F\u0938\u094D\u0925\u093F\u0924\u093F \u092E\u0947\u0902 \u0935\u093E\u092A\u0938 \u0928\u0939\u0940\u0902 \u0939\u094B\u0917\u093E\u0964 \u0906\u0902\u0936\u093F\u0915 \u0930\u0926\u094D\u0926\u0940\u0915\u0930\u0923 \u0915\u0940 \u0905\u0928\u0941\u092E\u0924\u093F \u0939\u0948\u0964"
    },
    "variantNew_h2_product_info":{  
       "en":"Product Info",
       "hin":"\u092A\u094D\u0930\u094B\u0926\u0941\u0915\u094D\u0924 \u0915\u0940 \u091C\u093E\u0928\u0915\u093E\u0930\u0940"
    },
    "variantNew_span_addtowishlist":{  
       "en":"Add to Wishlist",
       "hin":"Wishlist \u092E\u0947\u0902 \u0921\u093E\u0932\u0947\u0902"
    },
    "variantNew_span_addedtowishlist":{  
       "en":"Added to Wishlist",
       "hin":"Wishlist \u092E\u0947\u0902 \u0921\u093E\u0932\u093C\u093E \u0917\u092F\u093E \u0939\u0948"
    },
    "variantNew_pdpdeskab_goal":{  
       "en":"This Product Helps in",
       "hin":"\u092F\u0939 \u092A\u094D\u0930\u094B\u0926\u0941\u0915\u094D\u0924 \u092E\u0926\u0926 \u0915\u0930\u0924\u093E \u0939\u0948"
    },
    "variantNew_pdpdeskab_consumed_with":{  
       "en":"Generally Consumed With",
       "hin":"\u0906\u092E \u0924\u094C\u0930 \u092A\u0930"
    },
    "variantNew_pdpdeskab_know_more":{  
       "en":"Know More",
       "hin":"\u0905\u0927\u093F\u0915 \u091C\u093E\u0928\u093F\u090F"
    },
    "variantNew_s_link_view_all_reviews":{  
       "en":"View all Reviews",
       "hin":"\u0938\u092D\u0940 \u0938\u092E\u0940\u0915\u094D\u0937\u093E \u0926\u0947\u0916\u0947\u0902"
    },
    "variantNew_m_Delivery_and_Seller_Information":{  
       "en":"Delivery and Seller Information",
       "hin":"\u0935\u093F\u0924\u0930\u0923 \u0914\u0930 \u0935\u093F\u0915\u094D\u0930\u0947\u0924\u093E \u091C\u093E\u0928\u0915\u093E\u0930\u0940"
    },
    "variantNew_m_manufacturer_details":{  
       "en":"Manufacturer Details",
       "hin":"\u0928\u093F\u0930\u094D\u092E\u093E\u0924\u093E \u0935\u093F\u0935\u0930\u0923"
    },
    "variantNew_m_pincode":{  
       "en":"Your Pincode :",
       "hin":"\u0906\u092A\u0915\u093E \u092A\u093F\u0928\u0915\u094B\u0921 :"
    },
    "variantNew_m_authenticty":{  
       "en":"Authenticity",
       "hin":"\u0938\u0924\u094D\u092F\u0924\u093E"
    },
    "variantNew_m_Guaranteed":{  
       "en":"Guaranteed",
       "hin":"\u0917\u093E\u0930\u0902\u091F\u0940"
    },
    "variantNew_m_Secure":{  
       "en":"Secure",
       "hin":"\u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924"
    },
    "variantNew_m_Payments":{  
       "en":"Payments",
       "hin":"\u092D\u0941\u0917\u0924\u093E\u0928"
    },
    "variantNew_m_days":{  
       "en":"14 days",
       "hin":"14 \u0926\u093F\u0928"
    },
    "variantNew_m_return":{  
       "en":"Return Policy",
       "hin":"\u0935\u093E\u092A\u0938\u0940 \u0928\u0940\u0924\u093F"
    },
    "variantNew_m_h3_similar_product_msg":{  
       "en":"Similar product at better price!",
       "hin":"\u092C\u0947\u0939\u0924\u0930 \u092E\u0942\u0932\u094D\u092F \u092A\u0930 \u0938\u092E\u093E\u0928 \u0909\u0924\u094D\u092A\u093E\u0926!"
    },
    "variantNew_m_compare_now":{  
       "en":"Compare now",
       "hin":"\u0905\u092C \u0924\u0941\u0932\u0928\u093E \u0915\u0930\u0947\u0902"
    },
    "variantNew_m_rating":{  
       "en":"Ratings",
       "hin":"\u0930\u0947\u091F\u093F\u0902\u0917"
    },
    "variantNew_m_reviews":{  
       "en":"Reviews",
       "hin":"\u0938\u092E\u0940\u0915\u094D\u0937\u093E"
    },
    "variantNew_m_buy_combo":{  
       "en":"Buy Combo",
       "hin":"\u0915\u0949\u092E\u094D\u092C\u094B \u0916\u0930\u0940\u0926\u0947\u0902"
    },
    "variantNew_m_buy_for":{  
       "en":"Buy for",
       "hin":"\u0907\u0938\u0947 \u0916\u0930\u0940\u0926\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F"
    },
    "variantNew_m_combo_offers":{  
          "en":"Combo Offers",
          "hin":"\u0915\u0949\u092E\u094D\u092C\u094B \u0911\u092B\u0930"
    },
    "variantNew_m_about_product":{  
       "en":"About Product",
       "hin":"\u092A\u094D\u0930\u094B\u0926\u0941\u0915\u094D\u0924 \u091C\u093E\u0928\u0915\u093E\u0930\u0940"
    },
    "variantNew_m_overall_rating":{  
       "en":"Overall Rating",
       "hin":"\u0938\u092E\u0917\u094D\u0930 \u0930\u0947\u091F\u093F\u0902\u0917"
    },
    "variantNew_m_avg_rating":{  
       "en":"Average Rating",
       "hin":"\u0914\u0938\u0924 \u0930\u0947\u091F\u093F\u0902\u0917"
    },
    "variantNew_m_out_of_5":{  
       "en":"out of 5",
       "hin":"5 \u092E\u0947\u0902 \u0938\u0947"
    },
    "variantNew_m_small_ratings":{  
       "en":"ratings",
       "hin":"\u0930\u0947\u091F\u093F\u0902\u0917\u094D\u0938"
    },
    "variantNew_m_small_reviews":{  
       "en":"reviews",
       "hin":"\u0938\u092E\u0940\u0915\u094D\u0937\u093E"
    },
    "variantNew_m_view_more":{  
       "en":"View More",
       "hin":"\u0914\u0930 \u0926\u0947\u0916\u094B"
    },
    "variantNew_m_view_less":{  
       "en":"View Less",
       "hin":"\u0915\u092E \u0926\u0947\u0916\u0947\u0902"
    },
    "variantNew_m_EMI":{  
       "en":"EMI available",
       "hin":"EMI \u0909\u092A\u0932\u092C\u094D\u0927 \u0939\u0948"
    },
    "variantNew_m_from_rs":{  
       "en":"from ?",
       "hin":"\u20B9"
    },
    "variantNew_m_starts_from":{  
       "en":"starts from",
       "hin":"\u0936\u0941\u0930\u0942 \u0939\u094B\u0924\u093E \u0939\u0948"
    },
    "variantNew_m_per_month":{  
       "en":"per month",
       "hin":"\u092A\u094D\u0930\u0924\u093F \u092E\u093E\u0939"
    },
    "variantNew_m_li_about_product":{  
       "en":"About Product",
       "hin":"\u092A\u094D\u0930\u094B\u0926\u0941\u0915\u094D\u0924 \u0915\u0947 \u092C\u093E\u0930\u0947 \u092E\u0947\u0902"
    },
    "variantNew_m_similar_products":{  
       "en":"Similar Products",
       "hin":"\u0907\u0938\u0940 \u0924\u0930\u0939 \u0915\u0947 \u092A\u094D\u0930\u094B\u0926\u0941\u0915\u094D\u0924"
    },
    "variantNew_m_ratings_reviews":{  
       "en":"Rating & Reviews",
       "hin":"\u0930\u0947\u091F\u093F\u0902\u0917 \u0914\u0930 \u0938\u092E\u0940\u0915\u094D\u0937\u093E"
    },
    "variantNew_m_product_highlights":{  
       "en":"Product Highlights",
       "hin":"\u092A\u094D\u0930\u094B\u0926\u0941\u0915\u094D\u0924 \u0939\u093E\u0907\u0932\u093E\u0907\u091F\u094D\u0938"
    },
    "variantNew_m_safeandsecure_title":{  
       "en":"Safe & Secure Payment Methods",
       "hin":"\u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u092D\u0941\u0917\u0924\u093E\u0928 \u0935\u093F\u0927\u093F\u092F\u093E\u0902"
    },
    "variantNew_m_safeandsecure_l1":{  
       "en":"Credit / Debit card, Net Banking & UPI",
       "hin":"\u0915\u094D\u0930\u0947\u0921\u093F\u091F / \u0921\u0947\u092C\u093F\u091F \u0915\u093E\u0930\u094D\u0921, \u0928\u0947\u091F \u092C\u0948\u0902\u0915\u093F\u0902\u0917 \u0914\u0930 \u092F\u0942\u092A\u0940\u0906\u0908"
    },
    "variantNew_m_safeandsecure_l2":{  
       "en":"Mobile wallets (Paytm, MobiKwik, Freecharge & more)",
       "hin":"\u092E\u094B\u092C\u093E\u0907\u0932 \u0935\u0949\u0932\u0947\u091F (\u092A\u0947\u091F\u0940\u090F\u092E, \u092E\u094B\u092C\u093F\u0915\u0935\u093F\u0915, \u092B\u094D\u0930\u0940\u091A\u093E\u0930\u094D\u091C \u0914\u0930 \u0905\u0927\u093F\u0915)"
    },
    "variantComboItemTemplate_span_additional":{  
       "en":"Additional",
       "hin":"\u0905\u0924\u093F\u0930\u093F\u0915\u094D\u0924"
    },
    "variantComboItemTemplate_span_after":{  
       "en":"After",
       "hin":"\u092C\u093E\u0926"
    },
    "variantComboItemTemplate_span_after_new":{  
      "en":"",
      "hin":"\u092C\u093E\u0926"
   },
    "basicVariant_p_sold_out":{  
       "en":"Sold Out",
       "hin":"\u092C\u093F\u0915 \u0917\u092F\u093E"
    },
    "basicVariant_sucss_txt_mrp_rs":{  
       "en":"MRP ?",
       "hin":"\u090F\u092E\u0906\u0930\u092A\u0940 \u20B9"
    },
    "basicVariant_class_dispatched_in":{  
       "en":"DISPATCHED IN",
       "hin":"\u092D\u0940\u091C\u093E \u091C\u093E\u092F\u0947\u0917\u093E"
    },
    "basicVariant_class_days":{  
       "en":"DAYS",
       "hin":"\u0926\u093F\u0928 \u092E\u0947"
    },
    "basicVariant_menu_head_jump_to":{  
       "en":"Jump To",
       "hin":"\u0915\u0941\u0926\u0947\u0902"
    },
    "basicVariant_a_info":{  
       "en":"info",
       "hin":"\u091C\u093E\u0928\u0915\u093E\u0930\u0940"
    },
    "basicVariant_a_details":{  
       "en":"details",
       "hin":"\u0935\u093F\u0935\u0930\u0923"
    },
    "basicVariant_h2_combo_offers":{  
       "en":"Combo offers with this product",
       "hin":"\u0915\u0949\u092E\u094D\u092C\u094B \u0907\u0938 \u0909\u0924\u094D\u092A\u093E\u0926 \u0915\u0947 \u0938\u093E\u0925 \u0911\u092B\u0930 \u0915\u0930\u0924\u093E \u0939\u0948"
    },
    "baiscVariant_h2_with_this_pro":{  
       "en":"With this product, people also bought",
       "hin":"\u0907\u0938 \u0909\u0924\u094D\u092A\u093E\u0926 \u0915\u0947 \u0938\u093E\u0925, \u0932\u094B\u0917 \u092D\u0940 \u0916\u0930\u0940\u0926\u093E"
    },
    "basicVariant_h2_you_save":{  
       "en":"(You save",
       "hin":"(\u0906\u092A \u092C\u091A\u093E\u0924\u0947 \u0939\u0948\u0902"
    },
    "basicVariant_input_notify_me":{  
       "en":"Notify Me",
       "hin":"\u092E\u0941\u091D\u0947 \u0938\u0942\u091A\u093F\u0924 \u0915\u0930\u094B"
    },
    "basicVariant_div_now_rs":{  
       "en":"Now ?",
       "hin":"\u0905\u092C \u20B9"
    },
    "basicVariant_link_write_a_review":{  
       "en":"write a review",
       "hin":"\u0938\u092E\u0940\u0915\u094D\u0937\u093E \u0932\u093F\u0916\u0947"
    },
    "basicVariant_a_add_to_compare":{  
       "en":"Add to compare",
       "hin":"\u0924\u0941\u0932\u0928\u093E \u0915\u0930\u0947\u0902"
    },
    "basicVariant_div_instock":{  
       "en":"Instock",
       "hin":"\u0938\u094D\u091F\u0949\u0915 \u092E\u0947\u0902"
    },
    "askanexpert_span_get_consult_free":{  
       "en":"Get Consult Service for FREE",
       "hin":"\u092E\u0941\u092B\u094D\u0924 \u092E\u0947\u0902 \u092A\u0930\u093E\u092E\u0930\u094D\u0936 \u0938\u0947\u0935\u093E \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u0930\u0947\u0902"
    },
    "askanexpert_Nutritionist":{  
       "en":"Nutritionist",
       "hin":"\u092A\u094B\u0937\u0923 \u0935\u093F\u0936\u0947\u0937\u091C\u094D\u091E"
    },
    "askanexpert_fitness_trainer":{  
       "en":"Fitness Trainer",
       "hin":"\u092B\u093F\u091F\u0928\u0947\u0938 \u091F\u094D\u0930\u0947\u0928\u0930"
    },
    "askanexpert_date":{  
       "en":"Mon_Sat (10AM - 7PM)",
       "hin":"\u0938\u094B\u092E_\u0936\u0928\u093F (10AM - 7PM)"
    },
    "askexpert_get_free_consultation":{  
       "en":"Get free consultation from certified trainers and experienced nutritionists",
       "hin":"\u092A\u094D\u0930\u092E\u093E\u0923\u093F\u0924 \u092A\u094D\u0930\u0936\u093F\u0915\u094D\u0937\u0915\u094B\u0902 \u0914\u0930 \u0905\u0928\u0941\u092D\u0935\u0940 \u092A\u094B\u0937\u0923 \u0935\u093F\u0936\u0947\u0937\u091C\u094D\u091E\u094B\u0902 \u0938\u0947 \u0928\u093F: \u0936\u0941\u0932\u094D\u0915 \u092A\u0930\u093E\u092E\u0930\u094D\u0936 \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u0930\u0947\u0902"
    },
    "askexpert_a_know_more":{  
       "en":"Know more about this service",
       "hin":"\u0907\u0938 \u0938\u0947\u0935\u093E \u0915\u0947 \u092C\u093E\u0930\u0947 \u092E\u0947\u0902 \u0914\u0930 \u091C\u093E\u0928\u0947\u0902"
    },
    "variantCompareWidget_div_product_comparision":{  
       "en":"Product Comparison",
       "hin":"\u092A\u094D\u0930\u094B\u0926\u0941\u0915\u094D\u0924 \u0924\u0941\u0932\u0928\u093E"
    },
    "variantCompareWidget_a_clear_all":{  
       "en":"Clear All",
       "hin":"\u0938\u092D\u0940 \u0938\u093E\u092B \u0915\u0930\u0947\u0902"
    },
    "variantCompareWidget_p_add_another":{  
       "en":"Add another product to compare",
       "hin":"\u0924\u0941\u0932\u0928\u093E \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u090F\u0915 \u0914\u0930 \u092A\u094D\u0930\u094B\u0926\u0941\u0915\u094D\u0924 \u091C\u094B\u0921\u093C\u0947\u0902"
    },
    "reviewLayout_pro_summaryhead_pro_summary":{  
       "en":"Pro Summary",
       "hin":"\u092A\u094D\u0930\u094B \u0938\u093E\u0930\u093E\u0902\u0936"
    },
    "reviewLayout_span_verified_buyer":{  
       "en":"Verified Buyer",
       "hin":"\u0938\u0924\u094D\u092F\u093E\u092A\u093F\u0924 \u0916\u0930\u0940\u0926\u093E\u0930"
    },
    "reviewLayout_span_was_this_review_helpful":{  
       "en":"Was this review helpful?",
       "hin":"\u0915\u094D\u092F\u093E \u092F\u0939 \u0938\u092E\u0940\u0915\u094D\u0937\u093E \u0909\u092A\u092F\u094B\u0917\u0940 \u0925\u0940?"
    },
    "reviewLayout_span_yes":{  
       "en":"Yes",
       "hin":"\u0939\u093E\u0901"
    },
    "reviewLayout_a_report_abuse":{  
       "en":"Report Abuse",
       "hin":"\u0926\u0941\u0930\u0941\u092A\u092F\u094B\u0917 \u0939\u094B\u0928\u0947 \u0915\u0940 \u0938\u0942\u091A\u0928\u093E \u0926\u0947\u0902"
    },
    "Similar_Products":{  
       "en":"Similar Products",
       "hin":"\u0907\u0938\u0940 \u0924\u0930\u0939 \u0915\u0947 \u092A\u094D\u0930\u094B\u0926\u0941\u0915\u094D\u0924"
    },
    "You_May_Also_Like":{  
       "en":"You May Also Like",
       "hin":"\u0906\u092A\u0915\u094B \u092F\u0939 \u092D\u0940 \u092A\u0938\u0902\u0926 \u0906 \u0938\u0915\u0924\u093E \u0939\u0948\u0902"
    },
    "variantNew_Additional":{  
       "en":"Additional",
       "hin":"\u0905\u0924\u093F\u0930\u093F\u0915\u094D\u0924"
    },
    "variantNew_off":{  
       "en":"off",
       "hin":"\u092E\u093E\u092B"
    },
    "variantNew_combo":{  
       "en":"Combo",
       "hin":"\u0915\u0949\u092E\u094D\u092C\u094B"
    },
    "variantNew_disclaimer_thankyou":{  
       "en":"Thank you for your feedback!",
       "hin":"\u0906\u092A\u0915\u0940 \u092A\u094D\u0930\u0924\u093F\u0915\u094D\u0930\u093F\u092F\u093E \u0915\u0947 \u0932\u093F\u090F \u0906\u092A\u0915\u093E \u0927\u0928\u094D\u092F\u0935\u093E\u0926!"
    },
    "variantNew_view":{  
       "en":"View",
       "hin":"\u0914\u0930"
    },
    "variantNew_more":{  
       "en":"More",
       "hin":"\u0926\u0947\u0916\u0947\u0902"
    },
    "variantNew_weights":{  
       "en":"Weights",
       "hin":"\u0935\u091C\u0928"
    },
    "variantNew_weight":{  
       "en":"Weight",
       "hin":"\u0935\u091C\u0928"
    },
    "variantNew_flavours":{  
       "en":"Flavours",
       "hin":"\u092B\u094D\u0932\u0935\u094C\u0930"
    },
    "variantNew_flavour":{  
       "en":"Flavour",
       "hin":"\u092B\u094D\u0932\u0935\u094C\u0930"
    },
    "variantNew_view_less":{  
       "en":"View Less",
       "hin":"\u0915\u092E \u0926\u0947\u0916\u0947\u0902"
    },
    "variantNew_cod_available":{  
       "en":"Cash on delivery available",
       "hin":"\u0921\u093F\u0932\u0940\u0935\u0930\u0940 \u092A\u0930 \u0928\u0915\u0926 \u0909\u092A\u0932\u092C\u094D\u0927 \u0939\u0948"
    },
    "variantNew_cod_not_available":{  
       "en":"Cash on delivery not available",
       "hin":"\u0921\u093F\u0932\u0940\u0935\u0930\u0940 \u092A\u0930 \u0928\u0915\u0926 \u0909\u092A\u0932\u092C\u094D\u0927 \u0928\u0939\u0940\u0902 \u0939\u0948"
    },
    "variantNew_online_payment_avail":{  
       "en":"Online payment is available",
       "hin":"\u0911\u0928\u0932\u093E\u0907\u0928 \u092D\u0941\u0917\u0924\u093E\u0928 \u0909\u092A\u0932\u092C\u094D\u0927 \u0939\u0948"
    },
    "compare_add_to_compare":{  
       "en":"Add to Compare",
       "hin":"\u0924\u0941\u0932\u0928\u093E \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u091C\u094B\u0921\u093C\u0947\u0902"
    },
    "compare_added_to_compare":{  
       "en":"Added to Compare",
       "hin":"\u0924\u0941\u0932\u0928\u093E \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u091C\u094B\u0921\u093C\u093E \u0917\u092F\u093E"
    },
    "variantNew_invalid_pincode":{  
       "en":"Please enter a valid pincode",
       "hin":"\u0915\u0943\u092A\u092F\u093E \u090F\u0915 \u0935\u0948\u0927 \u092A\u093F\u0928\u0915\u094B\u0921 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902"
    },
    "combo_yousave":{  
       "en":"You Save ?",
       "hin":"\u0906\u092A \u092C\u091A\u093E\u0913 \u20B9"
    },
    "packVariant_pack_of":{  
       "en":"Pack of",
       "hin":"\u092A\u0948\u0915 \u0911\u092B\u093C"
    },
    "more_combos":{  
       "en":"more combos",
       "hin":"\u0905\u0927\u093F\u0915 \u0915\u0949\u092E\u094D\u092C\u094B"
    },
    "recently_viewed":{  
       "en":"Recently Viewed",
       "hin":"\u0939\u093E\u0932 \u092E\u0947\u0902 \u0939\u0940 \u0926\u0947\u0916\u093E \u0917\u092F\u093E"
    },
    "variantNew_fullfilled_by":{
        "en":"Fulfilled by HealthKart.",
        "hin":"\u0939\u0947\u0932\u094D\u0925\u0915\u093E\u0930\u094D\u091F \u0926\u094D\u0935\u093E\u0930\u093E \u092A\u0942\u0930\u093E \u0915\u093F\u092F\u093E \u0917\u092F\u093E"
    },
    "variantNew_freebie_box_more_offers":{
        "en":"more offers",
        "hin":"\u0905,\u0927\u093F\u0915 \u0911\u092B\u093C\u0930"
    },
    "varient_location_text":{
      "en":"USE MY LOCATION",
      "hin":"\u092e\u0947\u0930\u093e \u092a\u0924\u093e \u0907\u0938\u094d\u0924\u0947\u092e\u093e\u0932 \u0915\u0930\u094b"
   },
   "varient_pincode_info":{
      "en":"Enter pin code for exact delivery time/charges",
      "hin":"\u0938\u091f\u0940\u0915 \u0921\u093f\u0932\u0940\u0935\u0930\u0940 \u0938\u092e\u092f \u002f \u0936\u0941\u0932\u094d\u0915 \u0915\u0947 \u0932\u093f\u090f \u092a\u093f\u0928 \u0915\u094b\u0921 \u0926\u0930\u094d\u091c \u0915\u0930\u0947\u0902"
   },
   "varient_Delivery_by":{
      "en":"Delivery by ",
      "hin":"\u0921\u093f\u0932\u093f\u0935\u0930\u0940 \u0915\u093e \u0926\u093f\u0928"
   },
   "variantNew_h2_product_review_only":{  
      "en":"Reviews",
      "hin":"\u0930\u0947\u091F\u093F\u0902\u0917 \u0914\u0930 \u0938\u092E\u0940\u0915\u094D\u0937\u093E"
   }
}
export default vernacular;